import type { AxiosResponse } from "axios";

/**
 * Desempaca la envoltura `{ data, meta? }` del API a `data` puro.
 *
 * Convenciones §5.2: todas las respuestas vienen como `{ data, meta? }`.
 * Los queries normalmente usan `.then(unwrap)` para que React Query reciba
 * directamente la entidad.
 */
export interface ApiEnvelope<T> {
  data: T;
  meta?: { page: number; pageSize: number; total: number };
}

export interface PaginadoResultado<T> {
  items: T[];
  meta: { page: number; pageSize: number; total: number };
}

export function unwrap<T>(response: AxiosResponse<ApiEnvelope<T>>): T {
  return response.data.data;
}

export function unwrapPaginado<T>(response: AxiosResponse<ApiEnvelope<T[]>>): PaginadoResultado<T> {
  const body = response.data;
  return {
    items: body.data,
    meta: body.meta ?? { page: 1, pageSize: body.data.length, total: body.data.length },
  };
}
